module.exports = __webpack_public_path__ + "static/media/bcom-accounting_LR.51871b4c.jpg";